module.exports = __webpack_public_path__ + "static/media/connect-chart.344ca600.svg";